import { render, staticRenderFns } from "./DataCentrePackagePrices.vue?vue&type=template&id=4441c31e&"
import script from "./DataCentrePackagePrices.vue?vue&type=script&lang=js&"
export * from "./DataCentrePackagePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports